import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {

  @Input() title:string="";
  @Input() prefixMessage:string="Are you sure you want to delete";
  @Input() message:string="";
  @Input() suffixMessage:string="";
  @Input() label:string="";

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
